import React from 'react'
import './style.css'

const CtaSection = () => {

    return(
        <div className="cta-area">
            <div className="container">
                <div className="row">
                    <div className="col-lg-5 col-md-12 col-12">
                        <div className="cta-left">
                            <h2>If You Are Ready To Change Your Life. Contact Us Today!</h2>
                        </div>
                    </div>
                    <div className="col-lg-7 col-md-12 col-12">
                        <div className="cta-wrap">
                            <div className="cta-call">
                                <span>Call Us!</span>
                                <h3>203-555-1134</h3>
                            </div>
                            <div className="cta-call">
                                <span>E-mail Us!</span>
                                <h3>info@endependence.org</h3>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CtaSection;